import { useGetApiAssetsadvertIdSuspense } from "../api/rest/generated/assets-advert/assets-advert.ts";

const useDetail = (id: number) => {
	return useGetApiAssetsadvertIdSuspense(id);
};

export default useDetail;
